import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${props => (props.theme.isMobile ? '0' : '0px 0px 10px 0px')};

  > span {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-size: 20px;
    line-height: 22px;
    margin-right: 4px;
  }
`;

const Title = styled.span`
  color: ${props => props.theme.bodyColor};
  font-weight: ${props => props.theme.fontWeightHeavy};
`;

const Text = styled.span`
  color: ${props => props.theme.bodyColor};
`;

const Query = styled.span`
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: ${props => props.theme.primaryColor};
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function SidebarContributorsComponentHeader({ query }) {
  return (
    <Container>
      <Title>Contributors</Title>
      <Text>publishing</Text>
      <Text>about</Text>
      {!!query && <Query>{query}</Query>}
    </Container>
  );
}

SidebarContributorsComponentHeader.propTypes = {
  query: PropTypes.string,
};

SidebarContributorsComponentHeader.defaultProps = {
  query: null,
};
